import templates from './templates';
import pageApplicationContractCustom from './page/application/contract-custom-kfn';


templates['page/application/contractCustom'] = pageApplicationContractCustom;


export default templates;
